import { Component, Input, Output, ViewEncapsulation } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { MarketSeaProductsModel } from 'src/app/models/sea/market-sea-products.model';
import { MarketAirProductsModel } from 'src/app/models/air/market-air-products.model';
import { AirModel } from 'src/app/models/air/air-model';
import { ChangeLanguageService } from 'src/app/services/change-language.service';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { SearchLogClickHistoryService } from 'src/app/services/search-log-click-history.service';
import { ProductHasPricePipe } from 'src/app/shared/product-has-price-pipe/product-has-price.pipe';

export interface ReservationData {
  selectedProduct: MarketAirProductsModel | null;
  marketProductsDefId: number | null;
  productId: number | null;
  uuid: string | null;
}

const weekDaysMap: { [key: number]: string } = {
  1: "Pts",
  2: "Sal",
  3: "Çar",
  4: "Per",
  5: "Cum",
  6: "Cmt",
  7: "Paz"
};

@Component({
  selector: 'app-air-list',
  templateUrl: './air-list.component.html',
  styleUrls: ['./air-list.component.scss']
})


export class AirListComponent {

  @Input() model: AirModel = null;
  @Input() loading: boolean = false;
  @Output() makeReservation: EventEmitter<ReservationData> = new EventEmitter<ReservationData>();
  @Output() priceInfo: EventEmitter<MarketAirProductsModel> = new EventEmitter<MarketAirProductsModel>();
  @Output() priceRequest: EventEmitter<MarketAirProductsModel> = new EventEmitter<MarketAirProductsModel>();

  private lastClickHistoryAt = 0;

  
    constructor(private languageService: ChangeLanguageService, private searchLogHistoryService: SearchLogClickHistoryService, private pricePipe: ProductHasPricePipe) {
  
    }


  _makeReservation(selectedProduct: MarketAirProductsModel = null, marketProductsDefId = null, productId = null, uuid = null) {
    this.makeReservation.emit({selectedProduct,marketProductsDefId,productId, uuid})
  }

   async _clickRow(item: MarketAirProductsModel) {
    const hasPrice = this.pricePipe.transform(item, this.model, 'air');
    if(hasPrice) {
      const history  = await this.createClickHistory(item)
      if(history) {
        item.history = history;    
      }
      this.priceInfo.emit(item)
    } else { // fiyat yoksa
        this.priceRequest.emit(item);
    }
  }

  async _priceInfo(product: MarketAirProductsModel) {
    const history = await this.createClickHistory(product);
    if(history) {
      product.history = history;
    }
  
    this.priceInfo.emit(product)
    
  }

  createClickHistory(product: MarketAirProductsModel) {


      const now = Date.now();
      if (now - this.lastClickHistoryAt < 200) {
        return null;
      }
      this.lastClickHistoryAt = now;

      const model = new SearchLogClickHistoryModel();

      model.searchLogId = this.model?.id || null;
      model.productId = product?.id;
      model.productName = product?.name;
      model.uuid = product?.uuid;
      model.viewType = 'PRODUCTVIEW';
      model.info = 'LISTVIEW';

      return this.searchLogHistoryService.create(model).toPromise();
    }

  getShortWeekdays(days: string[]): string {
    if (!days || days.length === 0) return "";

    const language = this.languageService.getCurrentLanguage();
  
    const allDays = ["1", "2", "3", "4", "5", "6", "7"];
    
    const weekDaysMap = {
      tr: {
        1: "Pzt",
        2: "Sal",
        3: "Çar",
        4: "Per",
        5: "Cum",
        6: "Cmt",
        7: "Paz"
      },
      en: {
        1: "Mon",
        2: "Tue",
        3: "Wed",
        4: "Thu",
        5: "Fri",
        6: "Sat",
        7: "Sun"
      }
    };
  
    const allDaysLabel = language === 'tr' ? "Her Gün" : "Every Day";
  
    if (days.length === 7 && allDays.every(day => days.includes(day))) {
      return allDaysLabel;
    }
  
    const sortedDays = days.map(Number).sort((a, b) => a - b);
  
    return sortedDays
      .map(day => weekDaysMap[language][day] || "")
      .filter(Boolean)
      .join(",");
  }

  trackByProductId(index: number, item: MarketAirProductsModel): number | string {
  return item.uuid || item.id;
}
  
}
